import type { ReceiptOptions } from '@iws/pos-devices'

import { httpRequest } from '@/clients/http'

export const BusinessModel = {

  /** Business settings; the POS reads `app_settings.pos` (offline credit allowance §15.4, return window O9) and the
   *  receipt header (name, address, contact, `sst_id`). */
  getProfile: () =>
    httpRequest<{
      result: {
        name?: string
        address?: string
        contact_number?: string
        email?: string
        registration_number?: string
        sst_id?: string
        app_settings?: {
          pos?: {
            offline_credit_allowance?: number | null
            return_window_days?: number | null
            receipt_footer?: string | null
            receipt?: ReceiptOptions | null
          }
        }
      }
    }>({
      method: 'get',
      url: '/api/backoffice/profile/business',
    }),
}
